export enum STATUTORY_PAYMENT_TYPE {
  SSP = 'SSP',
  SMP = 'SMP',
  SAP = 'SAP',
  SPP_ADOPTION = 'SPPA',
  SPP_BIRTH = 'SPP',
}

export const STATUTORY_PAYMENT_OPTION = [
  { label: 'SSP', value: STATUTORY_PAYMENT_TYPE.SSP, route: 'ssp' },
  { label: 'SMP', value: STATUTORY_PAYMENT_TYPE.SMP, route: 'smp' },
  { label: 'SAP', value: STATUTORY_PAYMENT_TYPE.SAP, route: 'sap' },
  {
    label: 'SPP (Adoption)',
    value: STATUTORY_PAYMENT_TYPE.SPP_ADOPTION,
    route: 'spp-adoption',
  },
  {
    label: 'SPP (Childbirth)',
    value: STATUTORY_PAYMENT_TYPE.SPP_BIRTH,
    route: 'spp',
  },
];

export enum STATUTORY_PAYMENT_STATUS {
  NEW = 'NEW',
  PENDING = 'PENDING',
  FINISHED = 'FINISHED',
  STOPPED = 'STOPPED',
  ERROR = 'ERROR',
}

export const STATUTORY_PAYMENT_STATUS_OPTION = [
  { label: 'New', value: STATUTORY_PAYMENT_STATUS.NEW },
  { label: 'Pending', value: STATUTORY_PAYMENT_STATUS.PENDING },
  { label: 'Finished', value: STATUTORY_PAYMENT_STATUS.FINISHED },
  { label: 'Stopped', value: STATUTORY_PAYMENT_STATUS.STOPPED },
  { label: 'Error', value: STATUTORY_PAYMENT_STATUS.ERROR },
];

export const QUALIFYING_DAYS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export enum LEAVE_DURATION {
  ONE_WEEK = 'ONE_WEEK',
  TWO_WEEKS = 'TWO_WEEKS',
}

export const LEAVE_DURATION_OPTION = [
  { label: 'One week', value: LEAVE_DURATION.ONE_WEEK },
  { label: 'Two weeks', value: LEAVE_DURATION.TWO_WEEKS },
];

export enum ACTIONS_STATUTORY_TYPE {
  STOP = 'STOP',
  RESUME = 'RESUME',
  EDIT = 'EDIT',
}

export enum FORM_STATUTORY_TYPE {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

export enum STATUTORY_PAYMENT_DETAIL_STATUS {
  NEW = 'NEW',
  PENDING = 'PENDING',
  PAID = 'PAID',
  STOPPED = 'STOPPED',
}

export enum STATUTORY_TYPE {
  LEAVE = 'LEAVE',
  PAYMENT = 'PAYMENT',
}